import type { PrinterConnectionConfig, IPrinterConnection } from '../printerConnection.types'
import { OctoPrintAdapter } from './OctoPrintAdapter'
import { MoonrakerAdapter } from './MoonrakerAdapter'
import { BambuAdapter } from './BambuAdapter'

export { OctoPrintAdapter } from './OctoPrintAdapter'
export { MoonrakerAdapter } from './MoonrakerAdapter'
export { BambuAdapter } from './BambuAdapter'
export { BasePrinterAdapter } from './BasePrinterAdapter'

export function createPrinterAdapter(config: PrinterConnectionConfig): IPrinterConnection {
  switch (config.protocol) {
    case 'octoprint':
      return new OctoPrintAdapter(config)
    case 'moonraker':
      return new MoonrakerAdapter(config)
    case 'bambu':
      return new BambuAdapter(config)
    default:
      throw new Error(`Unsupported printer protocol: ${config.protocol}`)
  }
}

export const PROTOCOL_INFO: Record<string, {
  name: string
  description: string
  defaultPort: number
  requiresApiKey: boolean
  requiresAccessCode: boolean
  features: string[]
}> = {
  octoprint: {
    name: 'OctoPrint',
    description: 'Connect to OctoPrint server for any 3D printer',
    defaultPort: 80,
    requiresApiKey: true,
    requiresAccessCode: false,
    features: ['Full control', 'Webcam', 'File management', 'Plugin support'],
  },
  moonraker: {
    name: 'Klipper (Moonraker)',
    description: 'Connect to Klipper-based printers via Moonraker API',
    defaultPort: 7125,
    requiresApiKey: false,
    requiresAccessCode: false,
    features: ['Full control', 'High-speed data', 'Webcam', 'Macros'],
  },
  bambu: {
    name: 'Bambu Lab',
    description: 'Connect to Bambu Lab printers (X1, P1, A1 series)',
    defaultPort: 8883,
    requiresApiKey: false,
    requiresAccessCode: true,
    features: ['Camera', 'AMS support', 'Cloud sync', 'Print monitoring'],
  },
}
